module.exports = __webpack_public_path__ + "img/2.c5cb9cc5.gif";